import React, { useState, useEffect } from 'react'
import Input from './../../../input/Input';
import SelectItems from '../../../select-items/SelectItems';
import axios from 'axios';
import ApiUrl from '../../../../services/ApiUrl';
import Link from '../../../link/Link';
import { useSelector } from 'react-redux';

let validateNumber = 0;
const Accessories = ( props ) => {
    let [ load, setLoad ] = useState(false);
    let [ error, setErrors ] = useState(false);
    let [ forceValidate, setForceValidate ] = useState(false);
    let lang = props.langID

    useEffect(() => {
        if(!load && !props.edit) {
            props.onChange({
                title: "",
                accesories: [],
                link: {
                    url: '',
                    target: "false",
                    text: '',
                    uppercase: 'initial'
                },
            }, props.index);
            setLoad(true);
        }
        if(!load) {
            validateNumber = props.validate;
        }
    }, [load])

    useEffect(() => {
        if(!load && props.edit) {
            if(!props.data || Object.keys(props.data).length == 0) {
                props.onChange({
                    title: "",
                    accesories: [],
                    link: {
                        url: '',
                        target: "false",
                        text: '',
                        uppercase: 'initial'
                    },
                }, props.index);
            }
            setLoad(true);
        }
    }, [load])

    useEffect(() => {
        if(props.validate !== validateNumber) {
            validate();
        }
    }, [props.validate])

    const validate = async() => {
        await setForceValidate(true);
        await wait(100);
        await setForceValidate(false);
        let errors = await checkErrors();
        if(errors) {
            setErrors(true);
        }else{
            setErrors(false);
        }
    }

    const updateValue = (val, label) => {
        let newData = props.data;
        newData[label] = val;
        props.onChange({
            newData
        })
    }

    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll(`.accesories-list-${props.index} .error`);
        if( elements.length > 0 ) {
            result = true;
        } else {
            result = false;
        }
        return result;
    }

    console.log(props.data.accesories)

    return (
        <div className={error ? `section-wrapper accesories-list error-section accesories-list-${props.index}` : `section-wrapper accesories-list accesories-list-${props.index}`}>
            <div className="row-section">
                <Input  required={ false }
                    setFunction={ val => updateValue(val, 'title') }
                    value={props.data.title}
                    label={ 'Tytuł' }
                    regExp={ /.*/ }
                    minChar={ 3 } 
                    forceValidate={ forceValidate } 
                />
            </div>
            <div className="row-section">
                <div className="select-boxes">
                    <SelectItems
                        label="Kolekcje"
                        value={ props.data.accesories }
                        handle={ (val) => updateValue(val, 'accesories') } 
                        forceValidate={ forceValidate } 
                        langID={lang}
                        postType="accessories"
                        column="xs-12" />
                </div>
            </div>
            {/* {props.data.link && */}
                <div className="row-section"> 
                    <Link value={props.data.link} setFunction={ val => updateValue(val, 'link')} label="Link" />
                </div>
            {/* } */}
        </div>
    );
}

export default Accessories;